<template>
    <div class="DialogReportPaid__Component">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">הוספת קופון</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="DialogReportPaid__Component__Loading">
                    <b-field label="הזן קוד לקופון">
                        <b-input v-model="model.code"></b-input>
                    </b-field>
                    <b-field label="הזן שם לקופון">
                        <b-input v-model="model.name"></b-input>
                    </b-field>
                    <div style="margin-top: 20px;">
                        <b-radio v-model="discountType" name="name" native-value="percent">
                            הנחה באחוזים
                        </b-radio>
                        <b-radio v-model="discountType" name="name" native-value="amount">
                            הנחה בשקלים
                        </b-radio>
                    </div>
                    <b-field v-if="discountType == 'percent'" label="הנחה באחוזים לקופון">
                        <b-input type="number" v-model="model.discountPercentage"></b-input>
                    </b-field>
                    <b-field v-else label="הנחה בשקלים לקופון">
                        <b-input type="number" v-model="model.discountAmount"></b-input>
                    </b-field>
                    <FieldInlineDateTime label="תאריך תפוגה" :hide-hover="true"
                        position="is-bottom-left" v-model="model.expirationDate" />
                    <b-field label="הזן מלאי">
                        <b-input type="number" v-model="model.remainingUses"></b-input>
                    </b-field>
                    <b-field label="סטטוס">
                        <b-select v-model="model.status">
                            <option value="1">פעיל</option>
                            <option value="0">לא פעיל</option>
                        </b-select>
                    </b-field>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button :loading="isLoading" @click="save" label="שמור" type="is-primary" />
                <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import FieldInlineDateTime from "@/components/Fields/FieldInlineDateTime.vue";
import AdminService from "../services/AdminService";

export default {
    name: "DialogAddCoupon",
    props: ["reportNumbers", "reports", "onSuccess", "store"],
    components: {
        FieldInlineDateTime
    },
    computed: {
        courseId() {
            return this.store.state.auth.course?.id;
        },
    },
    data() {
        return {
            submitted: false,
            isLoading: false,
            discountType: 'percent',
            model: {
                code: null,
                name: null,
                discountPercentage: null,
                discountAmount: null,
                expirationDate: null,
                remainingUses: 1,
                status: 1
            }
        };
    },
    methods: {
        save() {
            if (this.model.code) {
                this.isLoading = true;
                AdminService.createCoupon({
                    ...this.model
                })
                    .then(() => {
                        Toast.open({
                            type: "is-success",
                            message: "הפעולה בוצעה!",
                            duration: 4000,
                        });
                        this.$emit("close");
                        window.location.reload();
                    }).catch(() => {
                        Toast.open({
                            type: "is-danger",
                            message: "לא היה ניתן לבצע את הפעולה, יש לפנות לתמיכה הטכנית.",
                            duration: 8000,
                        });
                    }).finally(() => {
                        this.isLoading = false;
                    });
            }
        },
        onIsCreateTask() {
            if (!this.isCreateTask) {
                this.isModalOpen = true;
            }
        },
        onTaskModelClose() {
            this.isModalOpen = false;
            this.isCreateTask = false;
        },
    },
};
</script>

<style lang="scss"></style>
